module.exports = __webpack_public_path__ + "img/close.5ffc4d27.svg";